import { BulletPointWithIconProps } from 'components/PageSections/components/BulletPointWithIcon';
import { ShapeBannerProps } from 'components/ShapeBanner';
import { isEmpty } from 'lodash-es';
import { ImageType } from 'utils/types';

import { TabbedBannersProps } from './TabbedBanners';

export const parseTabbedBanners = (
  section: Queries.ContentfulSection001,
): TabbedBannersProps | null => {
  let ShapeBannerList: ShapeBannerProps[] = [];

  const subsections = section?.subsections || [];

  if (isEmpty(subsections)) {
    return null;
  }

  // List of banners with a list of product slugs for each one
  const productSlugsByBanner: string[][] = [];

  subsections.forEach((subsection) => {
    if (
      isEmpty(subsection) ||
      !('body' in subsection) ||
      !subsection.body ||
      subsection.componentName !== 'ShapeBanner'
    ) {
      return;
    }

    const description = {
      raw: subsection.body.raw || '',
    };

    let desktopImage: ImageType | null = null;
    let mobileImage: ImageType | null = null;

    if (subsection.images && subsection.images.length > 0) {
      if (subsection.images[0]?.desktopImage?.gatsbyImageData) {
        desktopImage = {
          gatsbyImageData: subsection.images[0]?.desktopImage?.gatsbyImageData,
          description: subsection.images[0]?.desktopImageAltText || '',
        };
      }

      if (subsection.images[0]?.mobileImage?.gatsbyImageData) {
        mobileImage = {
          gatsbyImageData: subsection.images[0]?.mobileImage?.gatsbyImageData,
          description: subsection.images[0]?.mobileImageAltText || '',
        };
      }
    }

    const innerSubsections =
      subsection.subsections && subsection.subsections[0]
        ? (subsection.subsections as Queries.ContentfulSection001[])
        : null;

    const bulletsWithIcons: BulletPointWithIconProps[] = [];

    if (innerSubsections) {
      innerSubsections?.forEach((innerSubsection) => {
        if (
          !innerSubsection ||
          isEmpty(innerSubsection) ||
          !('componentName' in innerSubsection) ||
          innerSubsection.componentName !== 'BulletWithIcon'
        ) {
          return;
        }

        bulletsWithIcons.push({
          iconName: innerSubsection?.metadata?.context?.icon || '',
          text: innerSubsection?.metadata?.title || '',
        });
      });
    }

    const productSlugs: string[] = [];

    if (subsection.metadata?.context?.products) {
      subsection.metadata.context.products.forEach((product) => {
        if (product?.slug) {
          productSlugs.push(product.slug);
        }
      });
    }

    productSlugsByBanner.push(productSlugs);

    const shapeBannerData: ShapeBannerProps = {
      title: subsection.metadata?.title || '',
      description,
      desktopImage,
      mobileImage,
      desktopImageAltText: desktopImage?.description,
      mobileImageAltText: mobileImage?.description,
      cta: {
        displayName: subsection.metadata?.ctas?.[0]?.displayName || '',
        label: subsection.metadata?.ctas?.[0]?.label || '',
        url: subsection.metadata?.ctas?.[0]?.url || '',
      },
      backgroundColor: subsection.metadata?.theme?.backgroundColor || '',
      bulletPoints: bulletsWithIcons,
    };

    ShapeBannerList.push(shapeBannerData);
  });

  return {
    eyebrow: section?.eyebrow || '',
    title: section?.metadata?.title || '',
    shapeBannersData: ShapeBannerList,
    productSlugs: productSlugsByBanner,
  };
};
